import {
    Button,
    Divider,
    Fade,
    Grid,
    Modal,
    TextField,
    Typography,
} from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import { excursionModalStyles } from "./ExcursionsModalStyles";
import Backdrop from "@material-ui/core/Backdrop";
import { ReactComponent as CloseIcon } from "icons/CloseIcon.svg";
import clsx from "clsx";
import { ModalProps } from "./ModalProps";
import { useStore } from "store/StoreConfigs";
import { BatchStatusModel } from "api/thorRequestModels/Events/BatchStatusRequest";

export default observer(function ExcursionsModal(props: ModalProps) {
    const classes = excursionModalStyles();
    const { thorEventViewStore } = useStore();

    const [value, setValue] = React.useState(
        thorEventViewStore.eventSummary.batchSummaries.find(
            (x) => x.batchId === props.batchId
        )!.message
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    const onClose = () => {
        props.onClose();
    };

    const onConfirm = () => {
        const batchStatus: BatchStatusModel = {
            eventId: thorEventViewStore.eventDetails.eventId,
            batchId: props.batchId,
            isApproved: props.type === "apply",
            approvalMessage: value,
        };
        props.onConfirm(batchStatus);
    };

    return (
        <Modal
            className={classes.modal}
            open={props.isOpen}
            onClose={onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={props.isOpen}>
                <Grid
                    xs={4}
                    className={classes.paper}
                    container
                    direction="column"
                >
                    <Grid
                        className={classes.firstGrid}
                        container
                        direction="row"
                        justifyContent="space-between"
                    >
                        <Grid item>
                            <Typography>
                                Confirm your decision by including a short
                                summary
                            </Typography>
                        </Grid>
                        <Grid item>
                            <CloseIcon
                                className={classes.icon}
                                onClick={onClose}
                            />
                        </Grid>
                    </Grid>

                    <Divider />
                    <Grid
                        className={classes.secondGrid}
                        container
                        direction="row"
                    >
                        <Grid item xs={10}>
                            <TextField
                                style={{ margin: " 0px 8px 8px 8px" }}
                                placeholder="Explain your decision with a short summary..."
                                fullWidth
                                multiline
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={value}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>

                    <Divider />
                    <Grid
                        className={classes.thirdGrid}
                        container
                        direction="row"
                        justifyContent="space-between"
                    >
                        <Grid item></Grid>
                        <Grid item>
                            <Button
                                onClick={onClose}
                                className={
                                    classes.button + " " + classes.cancel
                                }
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={onConfirm}
                                className={clsx(classes.button, {
                                    [classes.confirm]: props.type === "apply",
                                    [classes.discard]: props.type === "discard",
                                })}
                            >
                                Confirm
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Fade>
        </Modal>
    );
});
